import React, { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar'; // Adjust based on your actual Navbar import

interface MainLayoutProps {
  children?: ReactNode; // Optional because Outlet will provide the children
}

const MainLayout: React.FC<MainLayoutProps> = () => {
  return (
    <div className='flex h-[100vh] bg-backgroundGrey'>
      <Navbar />
      <Outlet />
    </div>
  );
};

export default MainLayout;
